import type { TenantFeature, PerfilTenant } from '@/domain/model/TenantFeature';
import type {
  ListTenantFeaturesUseCase, ToggleFeatureUseCase, ApplyProfileUseCase,
} from '@/application/port/in/TenantFeatureUseCase';
import type {
  ToggleFeatureCommand, TenantFeatureGateway,
} from '@/application/port/out/TenantFeatureGateway';

export class ListTenantFeaturesUseCaseImpl implements ListTenantFeaturesUseCase {
  constructor(private readonly gw: TenantFeatureGateway) {}
  execute(): Promise<TenantFeature[]> { return this.gw.list(); }
}
export class ToggleFeatureUseCaseImpl implements ToggleFeatureUseCase {
  constructor(private readonly gw: TenantFeatureGateway) {}
  execute(c: ToggleFeatureCommand): Promise<TenantFeature> { return this.gw.toggle(c); }
}
export class ApplyProfileUseCaseImpl implements ApplyProfileUseCase {
  constructor(private readonly gw: TenantFeatureGateway) {}
  execute(p: PerfilTenant): Promise<void> { return this.gw.applyProfile(p); }
}
